import GoBackMenu from '@/components/GoBackNavbar';
import StudentViewSection from '@/components/StudentViewSection';
import Constants from '@/Constants';
import { useContentLanguageChange } from '@/hooks/useContentLanguageChange';
import { ViewType } from '@/models/ViewType';
import PageNotFound from '@/pages/PageNotFound/PageNotFound';
import { ApplicationState } from '@/store';
import { getCategoryClear, getCategoryRequest } from '@/store/category/action';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

const CategoryPage: React.FC = () => {
    const dispatch = useDispatch();
    const { id } = useParams<{ id: string }>();

    const { category, hasError } = useSelector((state: ApplicationState) => {
        const { hasError, data } = state.categories;
        const { category } = data;
        return { hasError, category };
    });

    useContentLanguageChange(
        {
            onChange: () => dispatch(getCategoryRequest(Number(id))),
            unmountChange: () => dispatch(getCategoryClear()),
        },
        [id],
    );

    return (
        <div className="section-page">
            <GoBackMenu />
            {hasError && <PageNotFound />}
            {category && category.id && <StudentViewSection viewType={(Constants.listCategorizedPrefix + category.id) as ViewType} />}
        </div>
    );
};

export default CategoryPage;
